<mat-card *ngIf="!loading" class="mcd-card">
  <mat-card-header
    class="mcd-card-header"
    style="
      display: flex;
      justify-content: space-between;
      padding-right: 12px;
      background: transparent;
      border: 1px solid #a0a0a04d;
      color: #34393f;
      border-left: none;
    "
  >
    <mat-card-title class="mcd-card-title">Manage Categories</mat-card-title>
  </mat-card-header>
  <div class="breadcrumbs clearfix">
    <div class="breadcrumbs-inner">
      <ul>
        <li>
          <a routerLink="/global-admin-panel" routerLinkActive="active"
            >Global Admin Panel</a
          >
        </li>
        <li class="separator">></li>
        <li class="active">Manage Categories</li>
      </ul>
    </div>
  </div>
  <mat-card-content class="mcd-card-content">
    <div class="row filter-panel-row" style="align-items: center; margin-bottom: 20px; display: flex; justify-content: space-between;">
      <div class="col-auto d-flex align-items-center" style="display: flex; gap: 15px; flex-wrap: wrap;">
        <!-- Search Input matching Suppliers / Upcoming Standards -->
        <div class="mcd-filter-dropdown-wrapper search-wrapper">
          <div class="mcd-search-header">
            <mat-icon class="search-icon">search</mat-icon>
            <input
              type="text"
              placeholder="Search by Name or Description"
              class="search-input-field"
              [(ngModel)]="searchKey"
              (keyup.enter)="addSearchKey(searchKey)"
              #key
            />
            <button
              type="button"
              class="clear-button"
              *ngIf="searchKey"
              (click)="searchKey = ''; addSearchKey('')"
            >
              <mat-icon class="clear-icon">close</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <div class="col-auto text-right">
        <button
          class="btn-add-supplier-gold"
          (click)="onAddEditCategory()"
        >
          <span class="material-icons add-icon">add_circle_outline</span>
          Add Category
        </button>
      </div>
    </div>

    <div class="table-wrapper" *ngIf="categoryList.categories.length > 0">
      <table class="table nrbes-grid">
        <thead class="thead-light">
          <tr>
            <th scope="col" width="30%">Name</th>
            <th scope="col" width="55%">Description</th>
            <th scope="col" width="15%" style="text-align: center;">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of categoryList.categories" [class.editing-row]="editingCategoryId === item.id">
            <!-- Read-only Row View -->
            <ng-container *ngIf="editingCategoryId !== item.id">
              <td
                class="location-cell"
                style="color: #3949a3; font-size: 14px;"
              >
                {{ item.name }}
              </td>
              <td class="description">
                <span title="{{ item.description }}" class="description">
                  {{ item.description }}
                </span>
              </td>
              <td (click)="$event.stopPropagation()" style="text-align: center;">
                <div class="grid-actions hide-sm" style="position: relative;">
                  <button
                    style="border: none; background: none; cursor: pointer;"
                    (click)="togglePopup($event, item)"
                  >
                    <img src="/assets/images/menu-dots 2.svg" />
                  </button>

                  <div
                    class="action-popup editDeletModal"
                    *ngIf="activePopupId === item.id"
                  >
                    <div
                      style="padding: 8px; text-align: left; cursor: pointer;"
                      class="onEditHover"
                      (click)="onEdit(item, $event)"
                    >
                      <a
                        class="action-controls"
                        style="
                          text-decoration: none;
                          color: rgba(63, 81, 181, 1);
                          font-size: 14px;
                          text-align: left;
                          display: block;
                          width: 100%;
                        "
                        title="Edit"
                        href="javascript:void(0);"
                      >
                        <span
                          ><img
                            src="/assets/images/d-edit 1.svg"
                            style="margin-bottom: 4px; margin-right: 5px;"
                        /></span>
                        <span>Edit</span>
                      </a>
                    </div>

                    <hr style="margin: 2px; border: 1px solid #dde1e6;" />

                    <div
                      style="padding: 8px; text-align: left; cursor: pointer;"
                      class="oDeleteHover"
                      (click)="openDeleteModal(item, $event)"
                    >
                      <a
                        class="action-controls"
                        style="
                          text-decoration: none;
                          color: rgba(222, 52, 40, 1);
                          font-size: 14px;
                          display: block;
                          width: 100%;
                        "
                        title="Delete"
                        href="javascript:void(0);"
                      >
                        <span
                          ><img
                            src="/assets/images/bin.svg"
                            style="margin-bottom: 4px; margin-right: 5px;"
                        /></span>
                        <span>Delete</span>
                      </a>
                    </div>
                  </div>
                </div>

                <a
                  (click)="actionMenuOpen($event)"
                  class="mcd-more-btn show-sm"
                  [matMenuTriggerFor]="menu"
                  href="javascript:void(0);"
                >
                  <i class="material-icons">more_vert</i>
                </a>
                <mat-menu #menu="matMenu" overlapTrigger="false">
                  <span>
                    <button mat-menu-item (click)="onEdit(item, $event)">
                      Edit
                    </button>
                    <button
                      mat-menu-item
                      (click)="closeMatMenuAndOpenDeleteModal(item, $event)"
                    >
                      Remove
                    </button>
                  </span>
                </mat-menu>
              </td>
            </ng-container>

            <!-- Inline Edit Mode View -->
            <ng-container *ngIf="editingCategoryId === item.id">
              <td class="inline-edit-cell" style="position: relative;">
                <input
                  type="text"
                  [(ngModel)]="editCategoryName"
                  class="inline-edit-input"
                  [class.has-error]="isEditCategoryNameDuplicate()"
                  placeholder="Category Name"
                />
                <div class="inline-error-tooltip" *ngIf="isEditCategoryNameDuplicate()">
                  <div class="tooltip-caret"></div>
                  <span class="tooltip-text">Name or title already taken</span>
                </div>
              </td>
              <td class="inline-edit-cell">
                <input
                  type="text"
                  [(ngModel)]="editCategoryDescription"
                  class="inline-edit-input"
                  placeholder="Category Description"
                />
              </td>
              <td class="inline-edit-actions" (click)="$event.stopPropagation()">
                <button
                  type="button"
                  class="btn-inline-save"
                  (click)="saveInlineCategory(item)"
                  [disabled]="!editCategoryName || !editCategoryDescription || isEditCategoryNameDuplicate()"
                >
                  Save
                </button>
                <button
                  type="button"
                  class="btn-inline-cancel"
                  (click)="cancelInlineEdit()"
                >
                  Cancel
                </button>
              </td>
            </ng-container>
          </tr>

          <!-- Inline New Category Addition View -->
          <tr *ngIf="isAddingNewCategory" class="editing-row">
            <td class="inline-edit-cell" style="position: relative;">
              <input
                type="text"
                [(ngModel)]="newCategoryName"
                class="inline-edit-input"
                [class.has-error]="isNewCategoryNameDuplicate()"
                placeholder="Category Name"
                #newCategoryInput
              />
              <div class="inline-error-tooltip" *ngIf="isNewCategoryNameDuplicate()">
                <div class="tooltip-caret"></div>
                <span class="tooltip-text">Name or title already taken</span>
              </div>
            </td>
            <td class="inline-edit-cell">
              <input
                type="text"
                [(ngModel)]="newCategoryDescription"
                class="inline-edit-input"
                placeholder="Category Description"
              />
            </td>
            <td class="inline-edit-actions" (click)="$event.stopPropagation()">
              <button
                type="button"
                class="btn-inline-save"
                (click)="saveNewCategory()"
                [disabled]="!newCategoryName || !newCategoryDescription || isNewCategoryNameDuplicate()"
              >
                Save
              </button>
              <button
                type="button"
                class="btn-inline-cancel"
                (click)="cancelAddNewCategory()"
              >
                Cancel
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
        *ngIf="categoryList.categories.length > 0"
      >
        <div>
          <div>
            <mat-form-field>
              <mat-select
                style="
                  padding: 8px 16px;
                  border: 1px solid #dde1e6;
                  border-radius: 4px;
                  background-color: #f8fafb;
                  color: #4d5258;
                  font-weight: 500;
                "
                [value]="pageSize"
                name="nOfRows"
                #items
                (selectionChange)="selectedItemsPerPageChange(items)"
              >
                <mat-option [value]="item.value" *ngFor="let item of pageSizes">
                  {{ item.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div>
          <div>
            <ngb-pagination
              class="float-right"
              [(page)]="page"
              [pageSize]="pageSize"
              [maxSize]="4"
              [rotate]="true"
              [ellipses]="true"
              [collectionSize]="collectionSize"
              (pageChange)="getCategoryList()"
            ></ngb-pagination>
          </div>
        </div>

        <div style="display: flex; gap: 10px">
          <button
            class="prevButton"
            [ngStyle]="{
              border: page == 1 ? '1px solid #E9ECEF' : '1px solid #C1C6CD',
              color: page == 1 ? '#696F77' : '#34393f',
            }"
            (click)="goToPreviousPage()"
          >
            <img src="/assets/images/leftarrow.svg" />

            Previous
          </button>
          <button
            class="nextButton"
            [ngStyle]="{
              border:
                page == totalPages ? '1px solid #E9ECEF' : '1px solid #C1C6CD',
              color: page == totalPages ? '#696F77' : '#34393f',
            }"
            (click)="goToNextPage()"
          >
            Next
            <img src="/assets/images/rightarrow.svg" />
          </button>
        </div>
      </div>
    </div>

    <div class="noResults" *ngIf="categoryList.categories.length == 0 && !searchKey">
      Sorry you do not have any category.
    </div>

    <div class="search-empty-state" *ngIf="categoryList.categories.length == 0 && searchKey">
      <img
        src="/assets/images/GRBES-List.svg"
        alt=""
        class="search-empty-icon"
      />
      <h4 class="search-empty-title">No results found</h4>
      <p class="search-empty-subtitle">
        Try a different keyword or refine your search to find what you're
        looking for.
      </p>
    </div>
  </mat-card-content>
</mat-card>
<app-mcd-loader class="mcd-page-loader" *ngIf="loading"></app-mcd-loader>

